import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Grid, Typography } from "@mui/material";
import dashboardApi from "Services/Dashboard";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { Equalizer, Savings , NotInterested , CarRepair ,Hail ,SensorOccupied, SupportAgent , Link ,
   Schedule , ContactPhone , PunchClock ,Close } from "@mui/icons-material";
// Date picker
import { Dayjs } from "dayjs";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector } from "react-redux";
import moment from 'moment-timezone';
import { CUSTOM_CONSTANTS } from "Constants";
const Dashboard = () => {
  const timezone = useSelector((state) => state?.timezone?.timezone || 'America/Anchorage');
  const classes = useStyles();
  const dispatch = useDispatch();
  const [dashboardDetails, setDashboardDetails] = useState(null);
  const [startDate, setStartDate] = useState({});
  const [endDate, setEndDate] = useState({});
  // Get dashboard details api
  const getDashbaordDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
   // console.log('Start date --->',startDate);
   // console.log('End date-->',endDate);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDashboardDetails(res?.data?.data);
      } else {
        setDashboardDetails([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get dashboard details Api", err);
    };
    dashboardApi.getDashboardDetails({startDate,endDate}).then(onSuccess, onFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate , endDate]);

  useEffect(() => {
    getDashbaordDetails();
  }, [getDashbaordDetails , startDate , endDate ]);


const handlefromdate = (newValue) => {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    setStartDate(formattedDate);
};

const handletodate = (newValue) => {
  const selectedDate =
    newValue instanceof Date ? newValue : new Date(newValue);
  const parsedDate = moment(selectedDate);
  const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
  setEndDate(formattedDate);
};

const containerStyle = {
display: "flex"
};

  return (
    <>
      <div style={containerStyle}>
        <div style={{ margin: "10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From Date"
              value={startDate}
              onChange={(newValue) => {
                handlefromdate(newValue);
                }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>

        <div style={{ margin: "10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To Date"
              value={endDate}
              onChange={(newValue) => {
                handletodate(newValue);
                }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
      </div>
      <br></br>
      <br></br>

      <Grid container className={classes.root} rowSpacing={3} >
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">Total No.of Rides</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h5">
                {dashboardDetails?.totalRidesCount || 0}
              </Typography> 
              <Equalizer/>
            </div>
            <div className={classes.dashboardicon}>
             
            </div>
          </section>
        </Grid>
        <Grid item xs={3}  className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">REVENUE</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {(dashboardDetails?.totalRevenue || 0)+" "+CUSTOM_CONSTANTS.BASE_CURRENCY}  
              </Typography>
              <Savings/>
            </div>
          </section>
        </Grid>
        <Grid item  xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">TOTAL KILOMETER DRIVEN</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {Number(dashboardDetails?.driverkilometerdriven || 0).toFixed(2)} KM
              </Typography>
              <SensorOccupied/>
            </div>
          </section>
        </Grid>
                <Grid item xs={3}  className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">TOTAL MINUTES SPENT</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {Number(dashboardDetails?.total_minutes || 0).toFixed(2)} Mins
              </Typography>
              <PunchClock/>
            </div>
          </section>
        </Grid>
        <Grid item xs={3}  className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">TOTAL CANCELLED RIDES</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {dashboardDetails?.cancelledRides || 0}
              </Typography>
              <NotInterested/>
            </div>
          </section>
        </Grid>
        <Grid item  xs={3}  className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">NO. OF SERVICE TYPES</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {dashboardDetails?.noOfServiceTypes || 0}
              </Typography>
              <CarRepair/>
            </div>
          </section>
        </Grid>
        <Grid item  xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">USER CANCELLED</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {dashboardDetails?.userCancelledRidesCount || 0}
              </Typography>
              <Hail/>
            </div>
          </section>
        </Grid>

        <Grid item xs={3}  className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">DISPATCHER CANCELLED</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {dashboardDetails?.dispatcherCancelledRidesCount || 0}
              </Typography>
              <SupportAgent/>
            </div>
          </section>
        </Grid>
        <Grid item xs={3}  className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">NO.OF CARRIER</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {dashboardDetails?.noOfCarrier || 0}
              </Typography>
              <Link/>
            </div>
          </section>
        </Grid>
        <Grid item  xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">NO. OF SCHEDULED RIDES</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {dashboardDetails?.scheduledRidesCount || 0}
              </Typography>
              <Schedule/>
            </div>
          </section>
        </Grid>
        <Grid item xs={3}  className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">NO. OF DISPATCHER RIDES</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {dashboardDetails?.dispatcherRidesCount || 0}
              </Typography>
              <ContactPhone/>
            </div>
          </section>
        </Grid>
        <Grid item xs={3}   className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">NOT ACCEPTED BY DRIVER</Typography>
            </div>
            <div className={classes.count}>
              <Typography variant="h4">
                {dashboardDetails?.driverNotAcceptedCount || 0}
              </Typography>
              <Close/>
            </div>
          </section>
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
